import React from "react";
import type { CmsMapContextState } from "./CmsMap.types";

export const CmsMapContext = React.createContext<CmsMapContextState>(
	{} as CmsMapContextState,
);
